import { useMutation } from '@tanstack/react-query';
import { useDataProvider } from 'ra-core';
import { type AdminDataProvider } from '../adminDataProvider';
import { useHttpClient } from '../useHttpClient';

interface GenerateInsightsForUnitArgs {
  unitId: string;
  files: File[];
}

export const useGenerateInsightsForUnit = () => {
  const client = useHttpClient();
  const dataProvider = useDataProvider<AdminDataProvider>();

  return useMutation({
    mutationKey: ['generateInsightsForUnit'],
    mutationFn: async ({ unitId, files }: GenerateInsightsForUnitArgs) => {
      const fileUrls = await Promise.all(
        files.map((file) =>
          dataProvider.uploadFile(
            {
              rawFile: file,
              title: file.name,
            },
            'public'
          )
        )
      );

      return await client.restApiKpis<{ text: string }>(
        `/kpis/unit/${unitId}/insights/llm`,
        {
          method: 'POST',
          body: JSON.stringify({
            fileUrls,
          }),
        }
      );
    },
  });
};
